import React, { ReactNode } from 'react';
import { ApolloProvider } from '@apollo/client';
import client from './client';
import { useRenewApolloLinkWhenTokensRenewed } from './hooks/useRenewApolloLinkWhenTokensRenewed';
import { useResetApolloLinkAfterLogin } from './hooks/useResetApolloLinkAfterLogin';

export type ProviderProps = {
  children: ReactNode;
};

export function GraphQlProvider({ children }: ProviderProps) {
  useRenewApolloLinkWhenTokensRenewed();
  useResetApolloLinkAfterLogin();

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}

export default GraphQlProvider;
